<template>
  <div id="water-control">
    <div class="water-fertilizer-control">
      <div class="water-control-title">
        <span class="water-control-titleContainer">设&emsp;备&emsp;控&emsp;制</span>
      </div>
      <div class="water-control-content">
        <div class="water-control-time">
          <div class="water-controlTime-title">
            <span class="water-controlTime-titleContainer">设备时间</span>
          </div>
          <div class="water-controlTime-set">
            <div class="water-controlTime-text">
              <span class="water-controlTime-textContainer">设备时间: -</span>
            </div>
            <div class="water-control-btn">
              <span class="water-control-btnContainer" @click="checkTime">时间校正</span>
            </div>
          </div>
        </div>
        <div class="water-control-main">
          <div class="water-controlMain-title">
            <span class="water-controlMain-titleContainer">注水控制</span>
          </div>
          <div class="water-controlMain-content">
            <div class="water-controlMain-div">
              <div class="water-controlMain-text">
                <span class="water-controlMain-textContainer">肥桶1注水</span>
              </div>
              <div class="water-controlMain-operate">
                <span class="water-controlMain-operateContainer" @click="changeFat1">{{fatBucket1}}</span>
              </div>
            </div>

            <div class="water-controlMain-div">
              <div class="water-controlMain-text">
                <span class="water-controlMain-textContainer">肥桶2注水</span>
              </div>
              <div class="water-controlMain-operate">
                <span class="water-controlMain-operateContainer" @click="changeFat2">{{fatBucket2}}</span>
              </div>
            </div>

            <div class="water-controlMain-div">
              <div class="water-controlMain-text">
                <span class="water-controlMain-textContainer">肥桶3注水</span>
              </div>
              <div class="water-controlMain-operate">
                <span class="water-controlMain-operateContainer" @click="changeFat3">{{fatBucket3}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WaterFertilizerControl',
    components:{},
    data() {
      return {
        fatBucket1: "关闭",
        fatBucket2: "关闭",
        fatBucket3: "关闭"
      }
    },

    mounted() {
      this.$message({
        showClose: true,
        type: "warning",
        message: "正在刷新数据"
      });
    },
    beforeDestroy() {},

    methods: {
      checkTime() {
        this.$message({
          showClose: true,
          type: "warning",
          message: "发送请求失败，请确认设备是否绑定并且在线"
        });
      },

      changeFat1() {
        this.fatBucket1  = this.fatBucket1 == "关闭" ? "开启": "关闭";
        this.$message({
          showClose: true,
          type: "warning",
          message: "发送请求失败，请确认设备是否绑定并且在线"
        });
      },

      changeFat2() {
        this.fatBucket2 = this.fatBucket2 == "关闭" ? "开启" : "关闭";
        this.$message({
          showClose: true,
          type: "warning",
          message: "发送请求失败，请确认设备是否绑定并且在线"
        });
      },

      changeFat3() {
        this.fatBucket3 = this.fatBucket3 == "关闭" ? "开启" : "关闭";
        this.$message({
          showClose: true,
          type: "warning",
          message: "发送请求失败，请确认设备是否绑定并且在线"
        });
      }
    }
  }
</script>

<style lang="less">
  @import "../less/waterFertilizerControl";
</style>



// WEBPACK FOOTER //
// src/components/view/waterFertilizerControl.vue